import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ptBRCommon from './locales/pt-BR/common.json';
import ptBRAuth from './locales/pt-BR/auth.json';
import ptBRConnectors from './locales/pt-BR/connectors.json';
import ptBRAgents from './locales/pt-BR/agents.json';
import ptBRTenants from './locales/pt-BR/tenants.json';
import ptBRKnowledge from './locales/pt-BR/knowledge.json';
import ptBRCallcenter from './locales/pt-BR/callcenter.json';
import ptBRErrors from './locales/pt-BR/errors.json';
import ptBRTeam from './locales/pt-BR/team.json';
import ptBRMonitor from './locales/pt-BR/monitor.json';
import ptBRBilling from './locales/pt-BR/billing.json';
import ptBRTemplates from './locales/pt-BR/templates.json';
import ptBRUsers from './locales/pt-BR/users.json';
import ptBRMarketplace from './locales/pt-BR/marketplace.json';
import ptBRAnalytics from './locales/pt-BR/analytics.json';
import ptBRManager from './locales/pt-BR/manager.json';
import ptBRPromptconfig from './locales/pt-BR/promptconfig.json';
import ptBRKpiconfig from './locales/pt-BR/kpiconfig.json';
import ptBRRegister  from './locales/pt-BR/register.json';
import ptBRSettings  from './locales/pt-BR/settings.json';
import ptBRTasks     from './locales/pt-BR/tasks.json';
import ptBRConnectorMgmt from './locales/pt-BR/connectorMgmt.json';
import ptBRHelp from './locales/pt-BR/help.json';
import ptBRTerms from './locales/pt-BR/terms.json';
import ptBRMktpl from './locales/pt-BR/mktpl.json';
import ptBROptout from './locales/pt-BR/optout.json';
import ptBRGroups from './locales/pt-BR/groups.json';
import ptBRAlexaLink from './locales/pt-BR/alexaLink.json';
import ptBRWizard from './locales/pt-BR/wizard.json';
import ptBRScheduling from './locales/pt-BR/scheduling.json';
import ptBRCampaigns from './locales/pt-BR/campaigns.json';

import esCommon from './locales/es/common.json';
import esAuth from './locales/es/auth.json';
import esConnectors from './locales/es/connectors.json';
import esAgents from './locales/es/agents.json';
import esTenants from './locales/es/tenants.json';
import esKnowledge from './locales/es/knowledge.json';
import esCallcenter from './locales/es/callcenter.json';
import esErrors from './locales/es/errors.json';
import esTeam from './locales/es/team.json';
import esMonitor from './locales/es/monitor.json';
import esBilling from './locales/es/billing.json';
import esTemplates from './locales/es/templates.json';
import esUsers from './locales/es/users.json';
import esMarketplace from './locales/es/marketplace.json';
import esAnalytics from './locales/es/analytics.json';
import esManager from './locales/es/manager.json';
import esPromptconfig from './locales/es/promptconfig.json';
import esKpiconfig from './locales/es/kpiconfig.json';
import esRegister  from './locales/es/register.json';
import esSettings  from './locales/es/settings.json';
import esTasks     from './locales/es/tasks.json';
import esConnectorMgmt from './locales/es/connectorMgmt.json';
import esHelp from './locales/es/help.json';
import esTerms from './locales/es/terms.json';
import esMktpl from './locales/es/mktpl.json';
import esOptout from './locales/es/optout.json';
import esGroups from './locales/es/groups.json';
import esAlexaLink from './locales/es/alexaLink.json';
import esWizard from './locales/es/wizard.json';
import esScheduling from './locales/es/scheduling.json';
import esCampaigns from './locales/es/campaigns.json';

import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enConnectors from './locales/en/connectors.json';
import enAgents from './locales/en/agents.json';
import enTenants from './locales/en/tenants.json';
import enKnowledge from './locales/en/knowledge.json';
import enCallcenter from './locales/en/callcenter.json';
import enErrors from './locales/en/errors.json';
import enTeam from './locales/en/team.json';
import enMonitor from './locales/en/monitor.json';
import enBilling from './locales/en/billing.json';
import enTemplates from './locales/en/templates.json';
import enUsers from './locales/en/users.json';
import enMarketplace from './locales/en/marketplace.json';
import enAnalytics from './locales/en/analytics.json';
import enManager from './locales/en/manager.json';
import enPromptconfig from './locales/en/promptconfig.json';
import enKpiconfig from './locales/en/kpiconfig.json';
import enRegister  from './locales/en/register.json';
import enSettings  from './locales/en/settings.json';
import enTasks     from './locales/en/tasks.json';
import enConnectorMgmt from './locales/en/connectorMgmt.json';
import enHelp from './locales/en/help.json';
import enTerms from './locales/en/terms.json';
import enMktpl from './locales/en/mktpl.json';
import enOptout from './locales/en/optout.json';
import enGroups from './locales/en/groups.json';
import enAlexaLink from './locales/en/alexaLink.json';
import enWizard from './locales/en/wizard.json';
import enScheduling from './locales/en/scheduling.json';
import enCampaigns from './locales/en/campaigns.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'pt-BR': {
        common: ptBRCommon,
        auth: ptBRAuth,
        connectors: ptBRConnectors,
        agents: ptBRAgents,
        tenants: ptBRTenants,
        knowledge: ptBRKnowledge,
        callcenter: ptBRCallcenter,
        errors: ptBRErrors,
        team: ptBRTeam,
        monitor: ptBRMonitor,
        billing: ptBRBilling,
        templates: ptBRTemplates,
        users: ptBRUsers,
        marketplace: ptBRMarketplace,
        analytics: ptBRAnalytics,
        manager: ptBRManager,
        promptconfig: ptBRPromptconfig,
        kpiconfig: ptBRKpiconfig,
        register: ptBRRegister,
        settings: ptBRSettings,
        tasks: ptBRTasks,
        connectorMgmt: ptBRConnectorMgmt,
        help: ptBRHelp,
        terms: ptBRTerms,
        mktpl: ptBRMktpl,
        optout: ptBROptout,
        groups: ptBRGroups,
        alexaLink: ptBRAlexaLink,
        wizard: ptBRWizard,
        scheduling: ptBRScheduling,
        campaigns: ptBRCampaigns,
      },
      en: {
        common: enCommon,
        auth: enAuth,
        connectors: enConnectors,
        agents: enAgents,
        tenants: enTenants,
        knowledge: enKnowledge,
        callcenter: enCallcenter,
        errors: enErrors,
        team: enTeam,
        monitor: enMonitor,
        billing: enBilling,
        templates: enTemplates,
        users: enUsers,
        marketplace: enMarketplace,
        analytics: enAnalytics,
        manager: enManager,
        promptconfig: enPromptconfig,
        kpiconfig: enKpiconfig,
        register: enRegister,
        settings: enSettings,
        tasks: enTasks,
        connectorMgmt: enConnectorMgmt,
        help: enHelp,
        terms: enTerms,
        mktpl: enMktpl,
        optout: enOptout,
        groups: enGroups,
        alexaLink: enAlexaLink,
        wizard: enWizard,
        scheduling: enScheduling,
        campaigns: enCampaigns,
      },
      es: {
        common: esCommon,
        auth: esAuth,
        connectors: esConnectors,
        agents: esAgents,
        tenants: esTenants,
        knowledge: esKnowledge,
        callcenter: esCallcenter,
        errors: esErrors,
        team: esTeam,
        monitor: esMonitor,
        billing: esBilling,
        templates: esTemplates,
        users: esUsers,
        marketplace: esMarketplace,
        analytics: esAnalytics,
        manager: esManager,
        promptconfig: esPromptconfig,
        kpiconfig: esKpiconfig,
        register: esRegister,
        settings: esSettings,
        tasks: esTasks,
        connectorMgmt: esConnectorMgmt,
        help: esHelp,
        terms: esTerms,
        mktpl: esMktpl,
        optout: esOptout,
        groups: esGroups,
        alexaLink: esAlexaLink,
        wizard: esWizard,
        scheduling: esScheduling,
        campaigns: esCampaigns,
      }
    },
    fallbackLng: 'pt-BR',
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
